// extracted by mini-css-extract-plugin
export default {"container":"Navigator_container__MYA4A","navButton":"Navigator_navButton__sR1Iv","deleteButton":"Navigator_deleteButton__pfjUR"};